<script setup lang="ts">
import type { ReleaseNote } from '../domain/releaseNote';
import ReleaseNoteView from 'shared/releaseNotes/components/ReleaseNoteView.vue';

const notes = defineModel<ReleaseNote[]>({ required: true });

</script>

<template>
  <div class="release-note-list">
    <ReleaseNoteView v-for="(note, index) in notes" v-bind:key="note.version" v-model:model-value="notes[index]!">
    </ReleaseNoteView>
  </div>
</template>

<style scoped>
.release-note-list {
  height: 100%;
  overflow-y: auto;
  display: flex;
  gap: 1rem;
  flex-direction: column;
}
</style>
